// extracted by mini-css-extract-plugin
export default {"container":"PaymentIntentStatus_container__Pf+hY","heading2Text":"PaymentIntentStatus_heading2Text__AD6fF"};